import styled from 'styled-components';

const ButtonsCenterInline = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 28px;

  @media (max-width: 576px) {
    display: block;
  }

  button, a {
    width: 200px;
    margin: 0 10px 0 0;

    &:last-child {
      margin: 0;
    }

    @media (max-width: 576px) {
      width: 100%;
      margin: 0 0 16px;
    }
  }
`;

export default ButtonsCenterInline;
